import styled from 'styled-components';
import { Type } from '../../../../../api/responses';
import { theme } from '../../../../../global';

export const MobileTableWrapper = styled.div<{ $competitionType: Type }>`
  display: flex;
  align-items: center;
  flex-direction: column;

  & > div:nth-of-type(even) {
    background: ${(props) => {
        switch (props.$competitionType) {
            case 'team':
                return '#F8FCF8';
            case 'quick':
                return '#FEFBF4';
            case 'classic':
                return '#F8F9FB';
            default:
                return '#F8F9FB';
        }
    }};
  };

  @media (min-width: 1100px) {
    display: none;
  }
`;

export const GameRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: ${theme.spacings.s24};
  padding: ${theme.spacings.s16} ${theme.spacings.s4};
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacings.s8};
`;

export const Container = styled.div`
  display: flex;
  gap: ${theme.spacings.s16};
  flex-direction: column;
`;

export const Situation = styled.span`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 500;
`;

export const PlayerContainer = styled.div<{ $isEmpty: boolean }>`
  display: flex;
  gap: ${theme.spacings.s8};
  flex-direction: column;
  min-height: ${(props) => (props.$isEmpty ? '84px' : 'auto')};
`;

export const Name = styled.span`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 600;
`;

export const PlayerItem = styled.div`
  display: flex;
  gap: ${theme.spacings.s8};
  align-items: center;
`;

export const Rating = styled.span`
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondaryText};
`;

export const Line = styled.hr`
  border-top: 1px solid ${theme.colors.line};
  width: 100%;
`;

export const StartLine = styled.div<{ $competitionType: Type }>`
  height: ${theme.spacings.s8};
  width: 100%;
  background: ${(props) => {
        switch (props.$competitionType) {
            case 'team':
                return theme.colors.greenHeader;
            case 'quick':
                return theme.colors.orangeHeader;
            case 'classic':
                return theme.colors.purpleHeader;
            default:
                return theme.colors.purpleHeader;
        }
    }};

    @media (min-width: 1100px) {
        display: none;
      }
`;
